import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

export const BOTTLES_RETURN_TOKEN = 'BOTTLES_RETURN';
export const RETURN_SLIP_TOKEN = 'RETURN_DOCUMENT';
export const VOUCHER_TOKEN = 'VOUCHER';

export function useCheckoutPreferences(config, wantsBottles, wantsVouchers) {
  const t = useTranslations('checkout');
  const [bottlesReturn, setBottlesReturn] = useState(undefined);
  const [shouldDisplayBottlesReturn, setShouldDisplayBottlesReturn] = useState(false);
  const [bottlesReturnSubtitle, setBottlesReturnSubtitle] = useState(t('bottles_return_subtitle'));
  const [vouchers, setVouchers] = useState(undefined);
  const [shouldDisplayVouchers, setShouldDisplayVouchers] = useState(false);
  const [vouchersSubtitle, setVouchersSubtitle] = useState(t('vouchers_subtitle'));
  const [returnSlip, setReturnSlip] = useState(undefined);
  const [shouldDisplayReturnSlip, setShouldDisplayReturnSlip] = useState(false);
  const [bottlesReturnInfo, setBottlesReturnInfo] = useState({
    count: 0,
    wantsToReturn: false,
  });

  useEffect(() => {
    if (!config) return;
    if (!config.order.checkout?.preferences) return;

    for (const preferencesItem of config.order.checkout.preferences) {
      if (preferencesItem.type === BOTTLES_RETURN_TOKEN && preferencesItem.enabled) {
        setBottlesReturn(0);
        setShouldDisplayBottlesReturn(true);
      }

      if (preferencesItem.type === RETURN_SLIP_TOKEN && preferencesItem.enabled) {
        setReturnSlip(false);
        setShouldDisplayReturnSlip(true);
      }
    }

    for (const paymentOptionItem of config.order.checkout.paymentOptions) {
      if (paymentOptionItem.type === VOUCHER_TOKEN && paymentOptionItem.enabled) {
        setVouchers(0);
        setShouldDisplayVouchers(true);
      }
    }
  }, [config]);

  useEffect(() => {
    // if (bottlesReturn) setBottlesReturnSubtitle(`${t('bottles_return_subtitle')} - ${bottlesReturn.toString()}`);
    if (bottlesReturn && wantsBottles) setBottlesReturnSubtitle(`${bottlesReturn.toString()} ${t('bottles')}`);
    else setBottlesReturnSubtitle(t('bottles_return_subtitle'));
  }, [bottlesReturn, setBottlesReturnSubtitle, wantsBottles]);

  useEffect(() => {
    if (vouchers && wantsVouchers) setVouchersSubtitle(`${vouchers} ${t('vouchers_title')}`);
    else setVouchersSubtitle(t('vouchers_subtitle'));
  }, [vouchers, setVouchersSubtitle, wantsVouchers]);

  useEffect(() => {
    setBottlesReturnInfo({
      count: bottlesReturn,
      wantsToReturn: wantsBottles,
    });
  }, [bottlesReturn]);

  return {
    bottlesReturn,
    setBottlesReturn,
    bottlesReturnSubtitle,
    vouchers,
    setVouchers,
    vouchersSubtitle,
    returnSlip,
    setReturnSlip,
    shouldDisplayBottlesReturn,
    shouldDisplayVouchers,
    shouldDisplayReturnSlip,
    bottlesReturnInfo,
  };
}
